import { render, staticRenderFns } from "./SecondTranDia.vue?vue&type=template&id=6e36fe41&scoped=true"
import script from "./SecondTranDia.vue?vue&type=script&lang=js"
export * from "./SecondTranDia.vue?vue&type=script&lang=js"
import style0 from "./SecondTranDia.vue?vue&type=style&index=0&id=6e36fe41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e36fe41",
  null
  
)

export default component.exports